import * as React from 'react';

export function HemXLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={58} height={15} fill="none" {...props}>
      <path
        d="M8.9.993v5.42H2.7V.993H0v13.6h2.7v-5.76h6.2v5.76h2.7V.992H8.9zm14.478 8.4c0-3.06-2.16-5.16-5.16-5.16s-5.18 2.38-5.18 5.32c0 2.96 2.24 5.34 5.36 5.34 2.08 0 3.72-.96 4.62-2.38l-1.96-1.24c-.5.82-1.42 1.4-2.64 1.4-1.46 0-2.6-.92-2.9-2.38h7.78c.04-.16.08-.56.08-.9zm-5.14-3.04c1.44 0 2.32.78 2.64 2.06h-5.3c.34-1.26 1.3-2.06 2.66-2.06zm18.064-2.1c-1.56 0-2.56.72-3.26 1.74-.6-1.08-1.72-1.74-3.12-1.74-1.24 0-2.28.58-2.84 1.58v-1.32h-2.42v10.08h2.5v-5.8c0-1.34.86-2.22 1.98-2.22 1.16 0 1.9.84 1.9 2.18v5.84h2.52v-5.8c0-1.34.84-2.22 1.98-2.22 1.18 0 1.9.84 1.9 2.18v5.84h2.5v-6.54c0-2.24-1.66-3.8-3.64-3.8zm21.597 10.34l-4.82-6.96 4.64-6.64h-3.16l-3.3 4.8L48 .993h-3.24l4.62 6.7-4.84 6.9h3.16l3.5-5.08 3.46 5.08h3.24z"
        fill="#60C9FB"
      />
    </svg>
  );
}
